import { useReveal } from "../lib/useReveal";

const rescues = [
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/1txdmqr5_WhatsApp%20Image%202026-04-25%20at%208.01.38%20PM%20%281%29.jpeg",
    tag: "Vaginal Prolapse",
    date: "18 March 2021",
    title: "An emergency, met with steady care.",
    body:
      "A critical case of severe vaginal prolapse was reported in a dairy cow requiring immediate surgical attention. The animal was examined, stabilised and prepared for emergency corrective treatment under controlled conditions. The exposed tissue was carefully cleaned and repositioned, followed by surgical retention procedures to prevent recurrence. Intensive post-operative care, medication and monitoring were provided to support complete recovery and reduce complications. The successful management of this case demonstrated effective emergency veterinary intervention and specialised large-animal reproductive surgery expertise.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/4yjfeciu_WhatsApp%20Image%202026-04-25%20at%208.01.17%20PM.jpeg",
    tag: "Abdominal Surgery",
    date: "09 September 2022",
    title: "On-site surgery, calm under pressure.",
    body:
      "A complex emergency abdominal surgery was conducted on-site for a cow suffering from a deep traumatic injury. The procedure involved careful tissue management, bleeding control and intensive post-operative monitoring. Despite the severity of the condition, the animal responded positively after treatment and rehabilitation. The case demonstrated advanced field surgical capability and coordinated veterinary teamwork under pressure.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/lfmicjbb_image.png",
    tag: "Abdominal Surgery",
    date: "09 September 2022",
    title: "Severe trauma — saved by skilled hands.",
    body:
      "A complex emergency abdominal surgery was conducted on-site for a cow suffering from a deep traumatic injury. The procedure involved careful tissue management, bleeding control and intensive post-operative monitoring. Despite the severity of the condition, the animal responded positively after treatment and rehabilitation. The case demonstrated advanced field surgical capability and coordinated veterinary teamwork under pressure.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/9z3fu41g_WhatsApp%20Image%202026-04-25%20at%208.01.38%20PM.jpeg",
    tag: "Papillomatosis",
    date: "14 July 2024",
    title: "Hundreds of growths — and a long road back.",
    body:
      "A cow suffering from extensive papillomatosis (multiple wart-like growths) around the neck and upper body region was brought for treatment. After clinical evaluation, a structured treatment and management plan was initiated to control infection and improve the animal's comfort and health. Continuous follow-up care and medical supervision resulted in visible recovery and a better quality of life for the animal.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/1637x6i4_WhatsApp%20Image%202026-04-25%20at%208.01.38%20PM%20%282%29.jpeg",
    tag: "Long-term Care",
    date: "06 November 2019",
    title: "Even the hardest cases.",
    body:
      "Severe lumpy skin disease — disfiguring, painful, slow to heal. We treat them daily, feed them gently, and never count the cost of compassion.",
  },
];

function RescueCard({ r, i }) {
  const reveal = useReveal();
  const flip = i % 2 === 1;

  return (
    <div
      ref={reveal}
      data-testid={`real-rescue-${i}`}
      className="reveal grid lg:grid-cols-12 gap-6 lg:gap-10 items-center"
      style={{ transitionDelay: `${i * 60}ms` }}
    >
      {/* Image */}
      <div
        className={`relative overflow-hidden rounded-2xl bg-[#F4F1EA] aspect-[4/3] ${
          flip ? "lg:col-span-7 lg:col-start-6" : "lg:col-span-7"
        }`}
      >
        <img
          src={r.src}
          alt={r.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-contain p-2 sm:p-3"
        />
        <div className="absolute top-5 left-5 inline-flex items-center gap-2 bg-[#1A2E24]/85 backdrop-blur-sm border border-[#D4AF37]/40 px-3 py-1.5 rounded-full">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] pulse-dot" />
          <span className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] font-semibold">
            {r.tag}
          </span>
        </div>
      </div>

      {/* Caption */}
      <div
        className={`${
          flip
            ? "lg:col-span-5 lg:col-start-1 lg:row-start-1 lg:pr-6"
            : "lg:col-span-5 lg:pl-6"
        }`}
      >
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#7A8C81] font-semibold">
          Case · 0{i + 1}
        </div>
        <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1A2E24] leading-[1.05] mt-4">
          {r.title}
        </h3>
        <p className="mt-5 text-[#4A5D53] leading-relaxed">{r.body}</p>
        <div className="mt-7 inline-flex items-center gap-3 text-[#1B4D3E]">
          <span className="h-[1px] w-10 bg-[#D4AF37]" />
          <span className="text-xs tracking-[0.28em] uppercase">
            From the field · {r.date}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function RealRescues() {
  const head = useReveal();
  return (
    <section
      id="real-rescues"
      data-testid="real-rescues-section"
      className="relative py-24 md:py-32 bg-[#FDFBF7] overflow-hidden"
    >
      {/* Soft top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-[#D4AF37] to-transparent" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={head} className="reveal max-w-3xl mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">
              From the field
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
            Real rescues. Real wounds.{" "}
            <span className="italic text-[#1B4D3E]">Real recovery.</span>
          </h2>
          <p className="mt-6 text-[#4A5D53] leading-relaxed max-w-2xl">
            These photographs are unedited. They show the actual condition in
            which animals reach our hospital — and the work our team does, day
            and night, to bring them back. Viewer discretion advised.
          </p>
        </div>

        <div className="space-y-24 md:space-y-32">
          {rescues.map((r, i) => (
            <RescueCard key={i} r={r} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
